import { render } from "./paygrade.vue?vue&type=template&id=5a62fd90&scoped=true"
import script from "./paygrade.vue?vue&type=script&lang=js"
export * from "./paygrade.vue?vue&type=script&lang=js"

import "./paygrade.vue?vue&type=style&index=0&id=5a62fd90&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a62fd90"]])

export default __exports__